import { createBrowserRouter } from 'react-router-dom';
import { routes } from './router/routes';
import { setRouter } from '@/shared/lib/routerRef';
import { getTenantCustomization } from '@customize/registry';
import { syncDocumentFavicon } from '@/runtime/documentBranding';

/**
 * Application Router
 *
 * Uses createBrowserRouter for improved performance and features:
 * - Better route matching before rendering
 * - Built-in error boundaries
 * - Support for data loaders and actions
 * - Improved TypeScript support
 */
export const router = createBrowserRouter(routes);

// Register in singleton so axios / auth providers can navigate without dynamic import.
setRouter(router);

// Head bootstrap handles the first request; route-level ownership avoids a
// login/shell unmount restoring the old icon during SSO or tenant navigation.
const syncRouteBranding = (pathname: string): void => {
  const site = pathname.split('/')[1];
  syncDocumentFavicon(document, getTenantCustomization(site)?.config?.theme.favicon);
};
syncRouteBranding(router.state.location.pathname);
const unsubscribeBranding = router.subscribe(({ location }) => {
  syncRouteBranding(location.pathname);
});
if (import.meta.hot) import.meta.hot.dispose(unsubscribeBranding);

